// This is a skeleton starter React component generated by Plasmic.
// This file is owned by you, feel free to edit as you see fit.
import * as React from "react";
import {
  PlasmicProfileSeoSimilarLinks,
  DefaultProfileSeoSimilarLinksProps
} from "./plasmic/paziresh_24_profile/PlasmicProfileSeoSimilarLinks";
import { HTMLElementRefOf } from "@plasmicapp/react-web";
import Link from "next/link";

// Your component props start with props for variants and slots you defined
// in Plasmic, but you can add more here, like event handlers that you can
// attach to named nodes in your component.
//
// If you don't want to expose certain variants or slots as a prop, you can use
// Omit to hide them:
//
// interface ProfileSeoSimilarLinksProps extends Omit<DefaultProfileSeoSimilarLinksProps, "hideProps1"|"hideProp2"> {
//   // etc.
// }
//
// You can also stop extending from DefaultProfileSeoSimilarLinksProps altogether and have
// total control over the props for your component.
export interface ProfileSeoSimilarLinksProps
  extends DefaultProfileSeoSimilarLinksProps {}

function ProfileSeoSimilarLinks_(
  props: ProfileSeoSimilarLinksProps,
  ref: HTMLElementRefOf<"div">
) {
  // Use PlasmicProfileSeoSimilarLinks to render this component as it was
  // designed in Plasmic, by activating the appropriate variants,
  // attaching the appropriate event handlers, etc.  You
  // can also install whatever React hooks you need here to manage state or
  // fetch data.
  //
  // Props you can pass into PlasmicProfileSeoSimilarLinks are:
  // 1. Variants you want to activate,
  // 2. Contents for slots you want to fill,
  // 3. Overrides for any named node in the component to attach behavior and data,
  // 4. Props to set on the root node.
  //
  // By default, we are just piping all ProfileSeoSimilarLinksProps here, but feel free
  // to do whatever works for you.

  // SEO: the generated item is a <div onClick> (router.push) — invisible to crawlers.
  // Render the clickable box as a real <a href> (next/link: client navigation, and the link is in
  // the server HTML). The generated onClick is dropped so navigation happens once.
  const { url } = props;
  return (
    <PlasmicProfileSeoSimilarLinks
      root={{ ref }}
      {...props}
      freeBox={
        url
          ? {
              render: ({ onClick, ...boxProps }: any) => (
                <Link href={url} prefetch={false} {...boxProps} />
              ),
            }
          : undefined
      }
    />
  );
}

const ProfileSeoSimilarLinks = React.forwardRef(ProfileSeoSimilarLinks_);
export default ProfileSeoSimilarLinks;
